import { deflateSync, inflateSync } from 'fflate';

function uint8ToBase64url(bytes: Uint8Array): string {
  let binary = '';
  for (let i = 0; i < bytes.length; i++) {
    binary += String.fromCharCode(bytes[i]);
  }
  return btoa(binary).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
}

function base64urlToUint8(str: string): Uint8Array {
  const base64 = str.replace(/-/g, '+').replace(/_/g, '/');
  const binary = atob(base64);
  const bytes = new Uint8Array(binary.length);
  for (let i = 0; i < binary.length; i++) {
    bytes[i] = binary.charCodeAt(i);
  }
  return bytes;
}

export function encodeScadToHash(code: string): string {
  const encoded = new TextEncoder().encode(code);
  const compressed = deflateSync(encoded, { level: 9 });
  return '#code=' + uint8ToBase64url(compressed);
}

export function isPreviewHash(hash: string): boolean {
  return hash.includes('&preview');
}

export function isEmbedHash(hash: string): boolean {
  return hash.includes('&embed');
}

export function decodeScadFromHash(hash: string): string | null {
  if (!hash.startsWith('#code=')) return null;
  // Strip &preview suffix before decoding
  let data = hash.slice(6);
  const ampIdx = data.indexOf('&');
  if (ampIdx !== -1) data = data.slice(0, ampIdx);
  if (!data) return null;
  try {
    const compressed = base64urlToUint8(data);
    const decompressed = inflateSync(compressed);
    return new TextDecoder().decode(decompressed);
  } catch {
    return null;
  }
}

export function buildShareUrl(code: string): string {
  return window.location.origin + window.location.pathname + encodeScadToHash(code);
}

export function buildPreviewUrl(code: string): string {
  return buildShareUrl(code) + '&preview';
}

export function buildEmbedUrl(code: string): string {
  return buildShareUrl(code) + '&embed';
}
